export default __webpack_public_path__ + "static/media/384.e6ea65c2.png";